import { createAction } from '@reduxjs/toolkit';

export const serviceActions = {
  //Actions
};
